import useFetch from '@hooks/useFetch';
import { processBatchDataFromAPI } from '@api/processors/batch';

export const getKey = (batchUID) => `v2/batch/${batchUID}/details/`;

const useBatchDetails = (batchUID) => {
  const key = getKey(batchUID);

  const { data: batchDetails, ...rest } = useFetch(batchUID ? key : null);

  return {
    key,
    batchDetails: processBatchDataFromAPI(batchDetails),
    ...rest
  };
};

export default useBatchDetails;
